import { COLUMN_COMPANY, COLUMN_DAYS_INACTIVE, COLUMN_DEPARTMENT, COLUMN_DISPLAY_NAME, COLUMN_FIRST_NAME, COLUMN_LAST_NAME, COLUMN_LAST_USED_DATE, COLUMN_SITE, COLUMN_TAG_CODE, COLUMN_TAG_TYPE, COLUMN_UNIQUE_IDENTIFIER, COLUMN_TITLE, COLUMN_SECOND_NAME, COLUMN_SUFFIX } from "../../constants/column-types";
import { FILTER_COMPANIES, FILTER_DEPARTMENTS, FILTER_SITES, FILTER_TAGHOLDERS, FILTER_INACTIVE_FOR, FILTER_CURRENT } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const CardsNotUsedReportColumns: TableColumn[] = [
    {
        heading: "Unique Identifier",
        accessor: "uniqueIdentifier",
        isNumeric: false,
        id: 10,
        active: false,
        translationKey: "uniqueIdentifier",
        columnId: COLUMN_UNIQUE_IDENTIFIER,
    },
    {
        heading: "Title",
        accessor: "title",
        isNumeric: false,
        id: 11,
        active: false,
        translationKey: "title",
        columnId: COLUMN_TITLE,
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "displayName",
        columnId: COLUMN_DISPLAY_NAME,
        lookupName: "mstDisplayname",
        searchOnName: "masterId",
        filterId: FILTER_TAGHOLDERS,
        settingDataName: "master",
    },
    {
        heading: "First Name",
        accessor: "firstName",
        isNumeric: false,
        id: 2,
        active: false,
        translationKey: "firstName",
        columnId: COLUMN_FIRST_NAME,
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        isNumeric: false,
        id: 12,
        active: false,
        translationKey: "secondName",
        columnId: COLUMN_SECOND_NAME,
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        isNumeric: false,
        id: 3,
        active: false,
        translationKey: "lastName",
        columnId: COLUMN_LAST_NAME,
    },
    {
        heading: "Suffix",
        accessor: "suffix",
        isNumeric: false,
        id: 13,
        active: false,
        translationKey: "suffix",
        columnId: COLUMN_SUFFIX,
    },
    {
        heading: "Company",
        accessor: "company",
        isNumeric: false,
        id: 4,
        searchOnName: "companyId",
        lookupName: "company",
        active: false,
        translationKey: "company",
        columnId: COLUMN_COMPANY,
        filterId: FILTER_COMPANIES,
        settingDataName: "company",
    },
    {
        heading: "Department",
        accessor: "department",
        isNumeric: false,
        id: 5,
        active: true,
        searchOnName: "departmentId",
        lookupName: "department",
        translationKey: "department",
        columnId: COLUMN_DEPARTMENT,
        filterId: FILTER_DEPARTMENTS,
        settingDataName: "department",
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 6,
        searchOnName: "site.id",
        lookupName: "site",
        active: true,
        translationKey: "site",
        columnId: COLUMN_SITE,
        filterId: FILTER_SITES,
        settingDataName: "site",
    },
    {
        heading: "Tag Code",
        accessor: "tagCode",
        isNumeric: false,
        id: 7,
        active: true,
        translationKey: "tagCode",
        columnId: COLUMN_TAG_CODE,
    },
    {
        heading: "Tag Type",
        accessor: "tagType",
        isNumeric: false,
        id: 8,
        active: false,
        translationKey: "tagType",
        columnId: COLUMN_TAG_TYPE,
    },
    {
        heading: "Last Used Date",
        accessor: "lastUsedDate",
        isNumeric: false,
        id: 14,
        active: true,
        translationKey: "lastUsedDate",
        columnId: COLUMN_LAST_USED_DATE,
    },
    {
        heading: "Days Inactive",
        accessor: "daysInactive",
        isNumeric: true,
        id: 15,
        active: true,
        translationKey: "daysInactive",
        columnId: COLUMN_DAYS_INACTIVE,
    },
    {
        heading: "Inactive For",
        accessor: "inactiveFor",
        searchOnName: "inactiveFor",
        isNumeric: false,
        id: 9,
        active: false,
        translationKey: "inactiveFor",
        filterId: FILTER_INACTIVE_FOR,
        settingDataName: "element",
        isFilterOnlyColumn: true,
    },
    {
        heading: "Current",
        accessor: "mstCurrent",
        searchOnName: "includeNonCurrent",
        lookupName: "includeNonCurrent",
        isNumeric: false,
        id: 16,
        active: false,
        translationKey: "includeNonCurrent",
        filterId: FILTER_CURRENT,
        isFilterOnlyColumn: true,
    },
];

export default CardsNotUsedReportColumns;